<section
  class="msg-box"
  #root
  (click)="onBoxClick($event)"
  [class.focused]="focused"
  [class.has-text]="!!text"
>
  <textarea
    #ta
    [id]="taId"
    [attr.name]="taId"
    [(ngModel)]="text"
    [disabled]="disabled"
    (input)="autoResize(ta); onInput()"
    (focus)="onFocus()"
    (blur)="onBlur()"
    (click)="onTextareaClick()"
    rows="1"
    (keydown)="onKeyDown($event)"
  ></textarea>
  @if (focused || text.length > 0) {
  } @else {
    <span class="textarea-placeholder">{{ hintText }}</span>
  }

  <section class="bottom-row" aria-hidden="false">
    <div class="left-icons">
      <div class="emoji-container">
        <button type="button" class="icon-btn" (click)="toggleEmojiPicker()">
          <img src="assets/icons/sentiment_satisfied.svg" alt="Emoji-picker-icon" />
        </button>
        <app-emoji-picker-component
          [showEmojiPicker]="showEmojiPicker"
          (emojiSelected)="addEmojiToText($event)"
          (closePicker)="showEmojiPicker = false"
        ></app-emoji-picker-component>
      </div>

      <button type="button" class="icon-btn" (click)="toggleMentionMode()">
        <img src="assets/icons/alternate_email.svg" alt="Erwähnen" />
      </button>
    </div>

    <button
      type="button"
      class="send-btn"
      [disabled]="!text.trim() || disabled"
      (click)="triggerSend()"
      aria-label="Nachricht senden"
    >
      <img class="send-icon" src="assets/icons/send.svg" alt="Senden" />
    </button>
  </section>

  <section class="mention-anchor">
    <app-mention-list
      [searchTerm]="mentionSearchTerm"
      [visible]="showMention"
      [mode]="mentionMode"
      [users]="mentionUsers"
      [channels]="mentionChannels"
      (pick)="insertMention($event)"
      (userSelected)="openDmFromMention($event)"
      (channelSelected)="openChannelFromMention($event)"
    ></app-mention-list>
  </section>
</section>
